import { cloneElement } from "react";
import useWindowDimensions from "../hooks/useWindowDimensions";

export default function Button({
  variant = "primary",
  size = "L",
  leftIcon,
  rightIcon,
  label,
  sx,
  onClick,
  fullWidth,
  disabled,
  rest,
}) {
  const { _, width } = useWindowDimensions();

  if (width <= 700)
    return (
      <button
        className={
          "mobile-body-text " +
          (variant === "primary"
            ? "button-primary-mobile"
            : variant === "secondary"
            ? "button-secondary-mobile"
            : "button-tertiary")
        }
        style={{
          paddingLeft: leftIcon || variant === "tertiary" ? "12px" : "24px",
          paddingRight: rightIcon || variant === "tertiary" ? "12px" : "24px",
          width: fullWidth ? "100%" : undefined,
          cursor: disabled ? "default" : "pointer",
          opacity: disabled ? 0.6 : 1,
          ...sx,
        }}
        onClick={onClick}
        disabled={disabled}
        {...rest}
      >
        {leftIcon &&
          cloneElement(leftIcon, {
            size: size === "L" ? 24 : 20,
            color: sx?.color
              ? sx?.color
              : variant === "primary"
              ? "white"
              : "#053137",
          })}
        {label}
        {rightIcon &&
          cloneElement(rightIcon, {
            size: size === "L" ? 24 : 20,
            color: sx?.color
              ? sx?.color
              : variant === "primary"
              ? "white"
              : "#053137",
          })}
      </button>
    );
  return (
    <button
      className={
        "body-text " +
        (variant === "primary"
          ? "button-primary"
          : variant === "secondary"
          ? "button-secondary"
          : "button-tertiary")
      }
      style={{
        height: size === "L" ? "52px" : "40px",
        paddingLeft: leftIcon || variant === "tertiary" ? "12px" : "24px",
        paddingRight: rightIcon || variant === "tertiary" ? "12px" : "24px",
        width: fullWidth ? "100%" : undefined,
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.6 : 1,
        ...sx,
      }}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {leftIcon &&
        cloneElement(leftIcon, {
          size: size === "L" ? 24 : 20,
          color: sx?.color
            ? sx?.color
            : variant === "primary"
            ? "white"
            : "#053137",
        })}
      {label}
      {rightIcon &&
        cloneElement(rightIcon, {
          size: size === "L" ? 24 : 20,
          color: sx?.color
            ? sx?.color
            : variant === "primary"
            ? "white"
            : "#053137",
        })}
    </button>
  );
}
